import React from "react";
import { Table } from "antd";
import { getCurrentShopId } from "../shop/get-current-shop";
import dayjs from "dayjs";

export default ({dataSource = []}) => { 
    
    return (
        <Table
            size="small"
            columns={[
                {
                    title: '券码',
                    dataIndex: 'id',
                },
                {
                    title: '核销时间',
                    dataIndex: 'usedTime',
                    render: (text, record) => {
                        return dayjs(text).format("YYYY-MM-DD HH:mm");
                    }
                },
                {
                    title: '核销人',
                    dataIndex: 'username',
                },
            ]}
            dataSource={dataSource}
            scroll={{ x: 'max-content' }}
        />
    )
};